// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"52885fef","395":"f24576cb","453":"871c25b6"}[chunkId] + ".chunk.js";
};